<template>
    <div class="home-page" @scroll="handleScroll">
        <div class="home-header" :class="{'home-header--fixed': true}">
            <div class="home-header__container">
                <h1 class="home-header__logo"></h1>
                <div class="header-nav">
                    <div
                        :class="['header-nav__item','header-nav__item--active']"
                        @mouseenter.native="activeNav='home'"
                        @mouseleave.native="activeNav=curNav">
                        首页
                    </div>
                    <a href="https://4020224467078.retail.n.weimob.com/saas/retail/4020224467078/6013963227078/shop/index" target="_blank">
                        <div
                            :class="['header-nav__item',activeNav==='shop'?'header-nav__item--active':'']"
                            @mouseenter.native="activeNav='shop'"
                            @mouseleave.native="activeNav=curNav">
                            好分数商城
                        </div>
                    </a>
                </div>
            </div>
        </div>
        <a href="https://4020224467078.retail.n.weimob.com/saas/retail/4020224467078/6013963227078/goods/detail?id=1398651140178" target="_blank" rel="noopener noreferrer">
            <div class="home-page__section home-page__section--banner">
                <div class="banner-btn-wrap">
                </div>
            </div>
        </a>
        <div class="home-page__section home-page__section--1 box">
                <h3 class="home-page__subtitle home-page__subtitle--01">300万人的共同选择</h3>
                <div class="number-data">
                    <div class="number-data__item">
                        <span class="number-data__number">40000</span>
                        <span class="number-data__text">全国合作院校</span>
                    </div>
                    <div class="number-data__item">
                        <span class="number-data__number">260<span class="number-data__plus">亿条</span></span>
                        <span class="number-data__text">考试数据</span>
                    </div>
                    <!-- <div class="number-data__item">
                        <span class="number-data__number">5000<span class="number-data__plus">+</span></span>
                        <span class="number-data__text">全国优秀老师</span>
                    </div> -->
                    <div class="number-data__item" style="text-align: center;width: 100%;">
                        <span class="number-data__number">300<span class="number-data__plus">万</span></span>
                        <span class="number-data__text">学习用户</span>
                    </div>
                </div>
                <div class="join-btn-wrap">
                </div>
        </div>
        <div class="home-page__section home-page__section--2">
            <h3 class="home-page__subtitle home-page__subtitle--02">为什么选择我们</h3>
            <div style="position:relative;height:3.7rem;overflow:hidden">
                <div class="reason-cards__main">
                    <div class="reason-cards swiper-wrapper">
                        <div class="swiper-slide" style="padding:0 .15rem">
                            <div class="reason-cards__item">
                                <span class="reason-cards__title">
                                    <span class="reason-cards__index">01.</span>全面分析本地化考情，圈定学习范围
                                </span>
                                <span class="reason-cards__text">分析当地中高考考纲考情，圈定本地考试范围及难度系数</span>
                            </div>
                        </div>
                        <div class="swiper-slide" style="padding:0 .15rem">
                            <div class="reason-cards__item">
                                <span class="reason-cards__title">
                                    <span class="reason-cards__index">02.</span>定位个人当地层次水平，明确学习方向
                                </span>
                                <span class="reason-cards__text">精准分析学生历次考试，定位当前学习水平，明确方向</span>
                            </div>
                        </div>
                        <div class="swiper-slide" style="padding:0 .15rem">
                            <div class="reason-cards__item">
                                <span class="reason-cards__title">
                                    <span class="reason-cards__index">03.</span>本地化教材解读，设计教学内容
                                </span>
                                <span class="reason-cards__text">针对当地教材合理设计教学内容，学生学习更有侧重点</span>
                            </div>
                        </div>
                        <div class="swiper-slide" style="padding:0 .15rem">
                            <div class="reason-cards__item">
                                <span class="reason-cards__title">
                                    <span class="reason-cards__index">04.</span>本地化共性错题，课后练习更高效
                                </span>
                                <span class="reason-cards__text">分析共性错题成因和考点，选取区域精品试题，课后刷题不盲目</span>
                            </div>
                        </div>
                        <div class="swiper-slide" style="padding:0 .15rem">
                            <div class="reason-cards__item">
                                <span class="reason-cards__title">
                                    <span class="reason-cards__index">05.</span>中高考数据分析，本地考向预测更到位
                                </span>
                                <span class="reason-cards__text">剖析当地考试大数据，预测中高考考向，靶向复习更有效</span>
                            </div>
                        </div>
                    </div>
                    <div class="reason-swiper-pagination"></div>
                </div>
            </div>
             <div class="join-btn-wrap">
            </div>
        </div>
        <div class="home-page__section home-page__section--3">
            <h3 class="home-page__subtitle home-page__subtitle--03">优秀老师，行业优选</h3>
            <div class="teachers-carousel-img"></div>
            <div style="position:relative;height:4.63rem;overflow:hidden" >
                <div class="teachers-carousel">
                    <div class="teachers-carousel__main">
                        <div class="teachers-carousel__swiper swiper-wrapper">
                            <div v-for="(teacher, index) in teacherCardsData" :key="index" class="teachers-carousel__card swiper-slide">
                                <img :src="teacher.avatar" alt="" class="teachers-carousel__teacher">
                                <div class="teachers-carousel__info">
                                    <div class="teachers-carousel__row-1">
                                        <span class="teachers-carousel__name">{{ teacher.name }}</span>
                                        <span class="teachers-carousel__tag">
                                            <span class="fs10" v-for="tag in teacher.teacherRankLabels" :key="tag">{{ tag }}</span>
                                        </span>
                                    </div>
                                    <div class="teachers-carousel__row-2">
                                        <div class="teacher-info">
                                            <div class="teacher-info__item">
                                                <span class="teacher-info__text txt-cut">{{ teacher.introduce }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="teachers-carousel__row-3">
                                        <span class="teachers-carousel__feature txt-cut" v-for="(feature,fIdx) in teacher.goodAt" :key="fIdx">{{ feature }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="teachers-swiper-pagination"></div>
                </div>
            </div>
            <div class="join-btn-wrap">
            </div>
        </div>
        <div class="home-page__section home-page__section--4">
            <h3 class="home-page__subtitle home-page__subtitle--04">个性化定制课程</h3>
            <div style="position:relative;height:8.6rem;overflow:hidden">
                <div class="lesson-carousel">
                    <div class="lesson-carousel__main">
                        <div class="lesson-carousel__card-group swiper-wrapper">
                            <div class="swiper-slide" v-for="lessons in LessonCardsData"
                                    :key="lessons.index">
                                <div class="lesson-carousel__card">
                                    <div class="lesson-carousel__name">
                                        {{ lessons.name }}
                                    </div>
                                    <div class="lesson-carousel__name2">
                                        {{ lessons.secondTitle }}
                                    </div>
                                    <div class="lesson-carousel__item">
                                        <span style="font-family: PingFangSC-Medium;font-size: .26rem;color: #333333;display:block">课程策略</span>
                                        <span style="display:block;font-family: PingFangSC-Regular;font-size: .26rem;color: #606266;">{{ lessons.des }}</span>
                                    </div>
                                    <div class="lesson-carousel__item2">
                                        <span style="font-family: PingFangSC-Medium;font-size: .26rem;color: #333333;display:block">课程结构</span>
                                    </div>
                                    <div class="lesson-carousel__item2">
                                        <div class="flex-center">
                                            <span class="sanjiao_down"></span>
                                            <span class="lesson-carousel__label">课前预习 </span>
                                        </div>
                                        <div class="lesson-carousel__txt">{{ lessons.beforeClass }}</div>
                                    </div>
                                    <div class="lesson-carousel__item2">
                                        <div class="flex-center">
                                            <span class="sanjiao_down"></span>
                                            <span class="lesson-carousel__label">课中讲/练 </span>
                                        </div>
                                        <div class="lesson-carousel__txt">{{ lessons.inClass }}</div>
                                    </div>
                                    <div class="lesson-carousel__item2">
                                        <div class="flex-center">
                                            <span class="sanjiao_down"></span>
                                            <span class="lesson-carousel__label">课后复习 </span>
                                        </div>
                                        <div class="lesson-carousel__txt">{{ lessons.afterClass }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="lesson-swiper-pagination"></div>
                    </div>
                </div>
            </div>
            <div class="join-btn-wrap">
            </div>
        </div>
        <div class="home-page__section home-page__section--5">
            <h3 class="home-page__subtitle home-page__subtitle--05">个性化学习更高效</h3>
            <div class="study-helps">
                <span class="study-helps__point study-helps__point--1"><span class="fz10">01</span></span>
                <span class="study-helps__point study-helps__point--2"><span class="fz10">02</span></span>
                <span class="study-helps__point study-helps__point--3"><span class="fz10">03</span></span>
                <span class="study-helps__point study-helps__point--4"><span class="fz10">04</span></span>
                <span class="study-helps__point study-helps__point--5"><span class="fz10">05</span></span>
                <div class="study-helps__text study-helps__text--1">大数据分析<br>精准诊断</div>
                <div class="study-helps__text study-helps__text--2">结合当地教学<br>定制提升方案</div>
                <div class="study-helps__text study-helps__text--3">智能匹配<br>合适老师</div>
                <div class="study-helps__text study-helps__text--4">在线约课<br>想学就学</div>
                <div class="study-helps__text study-helps__text--5">1对1专属<br>教学更有效</div>
            </div>
            <div class="join-btn-wrap">
            </div>
        </div>
        <div class="home-page__section home-page__section--6">
            <h3 class="home-page__subtitle home-page__subtitle--06">特色增值服务</h3>
            <div class="value-added-services">
                <div class="value-added-services__item">
                    <i class="value-added-services__icon value-added-services__icon--1"></i>
                    <span class="value-added-services__title">专业学业规划</span>
                    <div class="value-added-services__text">每人配备一个专业学习规划师为孩子的学习路径保驾护航。</div>
                </div>
                <div class="value-added-services__item">
                    <i class="value-added-services__icon value-added-services__icon--2"></i>
                    <span class="value-added-services__title">知识图谱</span>
                    <div class="value-added-services__text">对考点题型系统拆解，在学生脑海里构建出“知识树”，让学习更简单。</div>
                </div>
                <div class="value-added-services__item">
                    <i class="value-added-services__icon value-added-services__icon--3"></i>
                    <span class="value-added-services__title">三色笔记</span>
                    <div class="value-added-services__text">总结课堂上重要知识点，经典例题，解题方法和核心思路一眼即知。</div>
                </div>
                <div class="value-added-services__item">
                    <i class="value-added-services__icon value-added-services__icon--4"></i>
                    <span class="value-added-services__title">家长课堂</span>
                    <div class="value-added-services__text">组建学习群，定期推出学习习惯、方法等课程，让家长帮助孩子进步。</div>
                </div>
            </div>
        </div>
        <div class="home-page__section home-page__section--7">
            <h3 class="home-page__subtitle home-page__subtitle--07">服务保障</h3>
            <div class="service-protection">
                <div class="service-protection__pos">
                    <div class="service-protection__item service-protection__item--1">
                        <i class="service-protection__icon service-protection__icon--1"></i>
                        <span class="service-protection__text">先试听<br>满意再付费</span>
                    </div>
                    <div class="service-protection__item service-protection__item--2">
                        <i class="service-protection__icon service-protection__icon--2"></i>
                        <span class="service-protection__text">老师<br>任意选随时换</span>
                    </div>
                    <div class="service-protection__item service-protection__item--3">
                        <i class="service-protection__icon service-protection__icon--3"></i>
                        <span class="service-protection__text">课程不满意<br>随时退款</span>
                    </div>
                    <div class="service-protection__item service-protection__item--4">
                        <i class="service-protection__icon service-protection__icon--4"></i>
                        <span class="service-protection__text">7x14小时<br>专享贴心服务</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="home-page__section home-page__section--8">
            <h3 class="home-page__subtitle home-page__subtitle--08">企业荣誉</h3>
            <div style="position:relative;height:3.7rem;overflow:hidden">
                <div class="company-honor__main">
                    <div class="honor-cards swiper-wrapper">
                        <div class="swiper-slide">
                            <div class="honor-cards__item">
                                <img class="honor-cards__img"
                                    src="../../assets/images/homePage_new/home_11_1.png"
                                    alt="中国教育技术协会会员单位">
                                <span class="honor-cards__text">中国教育<br>技术协会会员单位</span>
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="honor-cards__item">
                                <img class="honor-cards__img"
                                    src="../../assets/images/homePage_new/home_11_2.png"
                                    alt="中关村前沿科技与产业服务联盟理事单位">
                                <span class="honor-cards__text">中关村前沿科技与<br>产业服务联盟理事单位</span>
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="honor-cards__item">
                                <img class="honor-cards__img"
                                    src="../../assets/images/homePage_new/home_11_3.png"
                                    alt="国家高新技术企业">
                                <span class="honor-cards__text">国家<br>高新技术企业</span>
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="honor-cards__item">
                                <img class="honor-cards__img"
                                    src="../../assets/images/homePage_new/home_11_4.png"
                                    alt="中关村高新技术企业">
                                <span class="honor-cards__text">中关村<br>高新技术企业</span>
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="honor-cards__item">
                                <img class="honor-cards__img"
                                    src="../../assets/images/homePage_new/home_11_5.png"
                                    alt="中关村前沿技术企业">
                                <span class="honor-cards__text">中关村<br>前沿技术企业</span>
                            </div>
                        </div>
                    </div>
                    <div class="reason-swiper-pagination"></div>
                </div>
            </div>
        </div>
        <div class="home-page__section home-page__section--footer">
            <div class="company-infos">
                <span class="company-infos__item">
                    <span class="fz9" >
                        <span @click="userAgreement">用户协议/</span>
                        <span @click="privacyAgreement">隐私政策/</span>
                        <span @click="childPrivaryPolicy">儿童隐私政策</span>
                    </span>
                </span>
                <span class="company-infos__item">
                    <span class="fz9">北京市海淀区东升科技园学院八号 北京修齐治平科技有限公司</span>
                </span>
                <span class="company-infos__item">
                    <a target="_blank" href="https://beian.miit.gov.cn/">
                        <span class="fz9">京ICP备16000182号-5</span>
                    </a>
                </span>
                <span class="company-infos__item">
                    <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502042360">
                        <span class="fz9"><img src="../../assets/images/common/gaba.png" class="footer-gaba">京公网安备11010502042360号</span>
                    </a>
                </span>
            </div>
        </div>
        <SignupDialog v-model="signupDialogVisible" />
    </div>
</template>

<script>

import Swiper from 'swiper';
import SignupDialog from './components/SignupDialog';
// import LazyImage from '../../assets/plugin/lazyImage';
import _ from 'lodash';
const TeacherCardsData = [
    {
        index: 1, // 对应图片文件名
        name: '赵艳君',
        tags: ['英语学科带头人', '10年教龄'],
        subject: '英语',
        count: '数千名学员',
        time: '数千小时',
        features: ['精准把握英语学科命题与学习规律',
            '出版经典学科类教辅书十余本',
            '注重互动式教学和引发学习兴趣']
    },
    {
        index: 2, // 对应图片文件名
        name: '王瑞',
        tags: ['语文高级教师', '13年教龄'],
        subject: '语文',
        count: '学员数千名',
        time: '数千小时',
        features: ['多年从事语文教研及一线教学工作',
            '熟悉各地中考考纲考情，擅长个别化精准指导',
            '激发学生学习兴趣，提高学生学习能力' ]
    },
    {
        index: 3, // 对应图片文件名
        name: '黄栋',
        tags: ['英语高级教师', '5年教龄'],
        subject: '英语',
        count: '数千名学员',
        time: '数千小时',
        features: ['深入研究英语命题和学习提升规律',
            '对薄弱生提升有独特方法',
            '注重启发式教学和情境教学']
    },
    {
        index: 4, // 对应图片文件名
        name: '杨元通',
        tags: ['数学高级教师', '5年教龄'],
        subject: '数学',
        count: '学员数百名',
        time: '数千小时',
        features: ['研究多年数学命题和学科学习规律',
            '擅长重难点题型拆分讲解',
            '注重化繁为简传授方法']
    },
    {
        index: 5, // 对应图片文件名
        name: '郭锦莎',
        tags: ['数学高级教师', '5年教龄'],
        subject: '数学',
        count: '学员数百名',
        time: '数千小时',
        features: ['精准把握高考考情及考试规律',
            '擅长重难点题型的方法总结及引导',
            '是关注学生学习心理的良师益友']
    }
];
const LessonCardsData = [
    {
        index: 1,
        name: '精准同步课',
        secondTitle: '紧密贴合学校进度   学习难度实时调控',
        des: '利用好分数独有的考试大数据精确定位学生当前学业等级，推荐同步学习胶囊，对学校正学的知识点进行全方位讲解。课后基因导学引擎为学生推荐个性化练习和测评，实时指导学习内容的调整。',
        beforeClass: '预习卡片、视频',
        inClass: '作业讲评、课程目标、知识讲解/例题/练习、课程总结',
        afterClass: '复习资料'
    },
    {
        index: 2,
        name: '考前复习课',
        secondTitle: '重点知识串讲梳理，定制最有效的备考方案',
        des: '根据考前所学内容进行串讲，构建知识网络。针对学生班级、年级的共性错题和历届学生的共性错题进行讲解训练，考前查漏补缺。提供备考策略，帮助学生做好复习。',
        beforeClass: '预习卡片、视频',
        inClass: '课程目标、知识串讲、错题-例题/练习、课程总结、备考策略',
        afterClass: '考前知识复习、考前综合练'
    },
    {
        index: 3,
        name: '考前冲关课',
        secondTitle: '易错点精准辅导，帮你成功闯关升级',
        des: '通过独家校本小53考情数据分析历年高频常考点、易错点进行重点讲解，结合学生个人错题数据，在考前攻克关键提升点。',
        beforeClass: '预习卡片、视频',
        inClass: '小53考情分析、复习计划、课程目标、错题精练、课程总结、备考策略',
        afterClass: '考前指南、考前冲刺卷、考前冲关练'
    },
    {
        index: 4,
        name: '考后分析课',
        secondTitle: '大数据考后诊断，全面补漏高效提升',
        des: '多维考试分析，全面识别学生知识和能力漏洞 。讲解典型错题并深挖错因，对错题背后的知识进行拓展讲解。针对试卷分析和错因分析，结合学生层级制定专属提升规划，及时调整，巩固提升。',
        beforeClass: '知识串讲',
        inClass: '本次试卷分析、课程目标、错题精讲、课程总结、考后规划',
        afterClass: '考后错题练、考后追踪卷'
    }
];

export default {
    components: {
        SignupDialog
    },
    data() {
        return {
            headerFixed: false,
            TeacherCardsData,
            LessonCardsData,
            lessonSwiper: null,
            reasonSwiper: null,
            teacherSwiper: null,
            signupDialogVisible: false,
            teacherCardsData: []
        };
    },
    beforeMount() {
        this.windowBindScroll();
    },
    mounted() {
        document.documentElement.style.fontSize = document.documentElement.clientWidth / 7.5 + 'px';
        window.addEventListener('resize', this.resizeHandler);
        // this.swiperInit();
        // this.lazyImageInit();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.resizeHandler);
        this.windowRemoveScroll();
    },
    created() {
        this.getTeacherCardsData();
    },
    methods: {
        resizeHandler() {
            let firstOnResizeFire = true;
            if (firstOnResizeFire) {
                document.documentElement.style.fontSize = document.documentElement.clientWidth / 7.5 + 'px';
                firstOnResizeFire = false;
                setTimeout(() => {
                    firstOnResizeFire = true;
                }, 500);
            }
        },
        swiperInit() {
            this.teacherSwiper = new Swiper('.teachers-carousel__main', {
                autoplay: true,
                loop: true,
                slidesPerView: 1.1,
                spaceBetween: 15,
                centeredSlides: true,
                pagination: {
                    el: '.teachers-swiper-pagination',
                    type: 'bullets'
                }
            });
            this.reasonSwiper = new Swiper('.reason-cards__main', {
                autoplay: true,
                loop: true,
                slidesPerView: 5,
                loopedSlides: 7,
                centeredSlides: true,
                pagination: {
                    el: '.reason-swiper-pagination',
                    type: 'bullets'
                }
            });
            this.lessonSwiper = new Swiper('.lesson-carousel__main', {
                // 前进后退按钮
                autoplay: true,
                loop: true,
                centeredSlides: true,
                // autoHeight: true,
                slidesPerView: 4,
                loopedSlides: 5,
                pagination: {
                    el: '.lesson-swiper-pagination',
                    type: 'bullets'
                }
            });
            this.honorSwiper = new Swiper('.company-honor__main', {
                autoplay: true,
                loop: true,
                slidesPerView: 3,
                loopedSlides: 5,
                centeredSlides: true,
                pagination: {
                    el: '.reason-swiper-pagination',
                    type: 'bullets'
                }
            });
        },
        windowBindScroll() {
            window.addEventListener('scroll', this.handleScroll);
        },
        windowRemoveScroll() {
            window.removeEventListener('scroll', this.handleScroll);
        },
        handleScroll: _.throttle(function(e) {
            const scrollTop = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop;
            this.headerFixed = scrollTop !== 0;
        }, 200),
        // 获取名师信息
        getTeacherCardsData() {
            this.$http.get('/v1/teachers/show-on-website/list?isFamous=1')
                .then(resp => this.$checkResp(resp))
                .then(data => {
                    this.teacherCardsData = data;
                    this.$nextTick(() => {
                        this.swiperInit();
                    });
                }).catch((err) => {
                    this.$handleError(err);
                });
        },
        // 跳转儿童协议
        childPrivaryPolicy() {
            window.location.href = `${feConfig.agreementUrl}/childPrivaryPolicy.html`;
        },
        // 跳转用户协议
        userAgreement() {
            window.location.href = `${feConfig.agreementUrl}/userAgreement.html`;
        },
        // 跳转隐私协议
        privacyAgreement() {
            window.location.href = `${feConfig.agreementUrl}/privaryPolicy.html`;
        }
    }
};
</script>

<style lang="scss" scoped>
.box {
    display: none;
}

.home-page {
    .home-header {
    width: 100%;
    top: 0;
    font-size: 14px;
    color: #000;
    z-index: 1000;
    transition: all linear 0.5s;

    &--fixed {
        position: fixed;
        top: 0;
        background: #FFFFFF;
        box-shadow: 0 4px 10px 0 rgba(0,0,0,0.05);

        .header-option {
            color: #4d4d4d;
            &__split {
                background: #ccc;
            }
        }
    }

    &__container {
        width: 1200px;
        height: 70px;
        line-height: 70px;
        margin: 0 auto;
        display: flex;
        align-items: center;
    }

    &__logo {
        flex: none;
        width: 40px;
        height: 100%;
        margin-right: 20px;
        background: url('../../assets/images/mobile/logo.png') no-repeat left center / auto 47px;
    }
}

.header-nav {
    flex: 1;
    font-size: 18px;
    position: relative;
    line-height: 32px;
    display: flex;

    a {
        text-decoration: none;
    }

    &__item {
        display: block;
        margin-right: 30px;
        color: #999;
        text-decoration: none;
        transition: all 0.2s;
        position: relative;

        &::after {
            content: ' ';
            width: 0;
            height: 2px;
            border-radius: 1px;
            background: #FC5A44;
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            margin: 0 auto;
            transition: all 0.2s;
        }

        &--active {
            color: #000;
            font-weight: bold;

            &::after {
                width: calc(100% - 6px);
            }
        }
    }
}

.header-option {
    flex: none;
    margin-right: -36px;
    line-height: 25px;
    font-size: 18px;
    color: #fff;
    position: relative;
    display: flex;
    align-items: center;
    transition: all linear 0.5s;

    &__avatar {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        margin-right: 10px;
    }

    &__user {
        position: relative;
        font-size: 14px;

        &:hover {
            .header-menu {
                display: block;
            }
        }
    }

    &__item {
        position: relative;
        &:hover .header-menu {
            display: block;
        }
    }

    &__btn {
        cursor: pointer;
    }

    &__split {
        margin: 0 12px;
        display: block;
        width: 1px;
        height: 14px;
        background: rgba(255, 255, 255, .5);
        transition: all linear 0.5s;
    }
}

.home-header-tip {
    position: absolute;
    top: 55px;
    right: 2px;
    width: 230px;
    height: 120px;
    line-height: 1;
    padding: 18px 16px;
    background-color: #fff;
    border-radius: 8px;
    box-sizing: border-box;
    color: #333;
    filter: drop-shadow(0 0 2px #999);

    &::before {
        position: absolute;
        top: -8px;
        right: 8px;
        content: ' ';
        width: 0;
        height: 0;
        border: 8px solid transparent;
        border-top: 0;
        border-bottom-color: #fff;
    }

    &__title {
        font-size: 16px;
        font-weight: 500;
    }

    &__desc {
        font-size: 14px;
        margin: 14px 0 24px;
    }

    &__btn {
        float: right;
        font-size: 14px;
        color: #2fc3e1;
        cursor: pointer;
        text-decoration: none;

        &:hover {
            color: darken(#2fc3e1, 7%);
        }
    }
}

.user-info {
    display: inline-block;

    &__avatar {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        vertical-align: middle;
    }

    &__btn {
        cursor: pointer;
    }

    &__text {
        display: inline-block;
        vertical-align: middle;
        margin-left: 10px;
        position: relative;

        &:hover {
            .header-menu {
                display: block;
            }
        }
    }
}
.header-menu {
    display: none;
    position: absolute;
    top: 22px;
    right: 0;
    border-top: 8px solid transparent;
    filter: drop-shadow(0 0 2px #999);

    &__container {
        background-color: #fff;
        border-radius: 2px;
        &::before {
            position: absolute;
            top: -8px;
            right: 6px;
            content: ' ';
            width: 0;
            height: 0;
            border: 8px solid transparent;
            border-top: 0;
            border-bottom-color: #fff;
        }
    }

    &__link {
        font-size: 14px;
        display: block;
        width: 100px;
        height: 34px;
        line-height: 34px;
        text-align: center;
        text-decoration: none;
        color: #5a5e66;
        cursor: pointer;

        &:hover {
            background-color: #cddefd;
        }
    }
}

    width: 100%;

    &__section {
        &--banner {
            width: 100%;
            background: url('../../assets/images/mobile/shop-1.jpg') no-repeat;
            height: 0;
            padding-bottom: 100%;
            overflow: hidden;
            position: relative;
            background-size: cover;
            top: 70px;
        }
        &--1 {
            background: #fff url('../../assets/images/mobile/home_01_bg.png') no-repeat top center / 7.5rem auto;
            height: 7.36rem;
        }
        &--2 {
            height: 8.16rem;
            background: #fff url('../../assets/images/mobile/home_02_bg.png') no-repeat top center / cover;
        }
        &--3 {
            height:13.7rem;
            background: #fff;
        }
        &--4 {
            height: 12.88rem;
            background: url('../../assets/images/mobile/home_04_bg.png') no-repeat top center / 7.5rem auto;
        }
        &--5 {
            height: 9.2rem;
            background: #fff;
            // background: url('../../assets/images/mobile/home_04_bg.png') no-repeat top center / 7.5rem auto;
            .join-btn-wrap {
                margin-top: -0.23rem;
            }
        }
        &--6 {
            height: 11.32rem;
            background: #fafafa;
        }
        &--7 {
            height: 7.87rem;
            background: #fff;
        }
        &--8 {
            height: 6.85rem;
            background: #fff;
        }
        &--footer {
            background: #333;
        }
    }

    &__subtitle {
        text-align: center;
        font-family: PingFangSC-Medium;
        font-size: .46rem;
        color: #000000;
        padding-top: 1.35rem;

        &--01 {
            background: url('../../assets/images/mobile/home_01_bt.png') no-repeat center .8rem / 1.21rem auto;
            margin-bottom: .8rem;
            margin-top:.53rem;
        }
        &--02 {
            color:#fff;
            background: url('../../assets/images/mobile/home_02_bt.png') no-repeat center .8rem / 1.21rem auto;
            margin-bottom: 1rem;
        }
        &--03 {
            background: url('../../assets/images/mobile/home_03_bt.png') no-repeat center .8rem / 1.21rem auto;
            margin-bottom: .58rem;
        }
        &--04 {
            color:#fff;
            background: url('../../assets/images/mobile/home_04_bt.png') no-repeat center .8rem / 1.21rem auto;
            margin-bottom: .9rem;
        }
        &--05 {
            background: url('../../assets/images/mobile/home_05_bt.png') no-repeat center .8rem / 1.21rem auto;
            margin-bottom: 1.9rem;
        }
        &--06 {
            background: url('../../assets/images/mobile/home_06_bt.png') no-repeat center .8rem / 1.21rem auto;
            margin-bottom: 0.9rem;
        }
        &--07 {
            background: url('../../assets/images/mobile/home_07_bt.png') no-repeat center .8rem / 1.21rem auto;
            margin-bottom: 0.9rem;
        }
        &--08 {
            background: url('../../assets/images/mobile/home_08_bt.png') no-repeat center .8rem / 1.21rem auto;
            margin-bottom: 0.92rem;
        }
    }
}
.banner-btn-wrap{
    position: absolute;
    top:7.83rem;
    left:1.3rem;
    transform: scale(.5);
    transform-origin: left top;
}

.banner-btn {
    display: block;
    width: 4.9*2rem;
    height: .8*2rem;
    background: linear-gradient(-88deg, #FF7300 3%, #FF9B00 98%);;
    box-shadow: 0 .1*2rem .2*2rem 0 rgba(255,133,0,0.30);
    border-radius: .52*2rem;
    color: #fff;
    font-size: .3*2rem;
    font-family: PingFangSC-Medium;
    line-height: .8*2rem;
    text-align: center;
    text-decoration: none;
    cursor: pointer;
}

.number-data {
    display: flex;
    width:4.06rem;
    margin: 0 auto .2rem;
    flex-wrap: wrap;
    &__item {
        display: flex;
        flex-direction: column;
        width:50%;
        text-align: center;
        margin-bottom: 0.4rem;
    }

    &__number {
        font-size: .44rem;
        color: #000000;
        margin-bottom: .15rem;
    }

    &__plus {
        font-size: .20rem;
        font-weight: normal;
    }

    &__text {
        font-size: .24rem;
        color: #666;
    }
}
.join-btn-wrap{
    transform: scale(.5);
    transform-origin: 0% 0%;
    margin:0 1.5rem;
}
.join-btn {
    font-family: PingFangSC-Regular;
    display: block;
    width: 4.5*2rem;
    height: .78*2rem;
    border-radius: .52*2rem;
    background-image: linear-gradient(135deg, #FF5A00 0%, #FF2500 100%);
    box-shadow: 0 .06*2rem .2*2rem 0 rgba(244,102,75,0.28);
    text-align: center;
    line-height: .78*2rem;
    font-size: .3*2rem;
    color: #FFFFFF;
    font-weight: bold;
    margin: 0 auto;
    cursor: pointer;
}
.reason-cards__main{
    height:3.7rem;
    width:6.5*5rem;
    left:50%;
    margin-left:-3.25*5rem;
    position: absolute;
        .swiper-pagination-bullets {
            position: absolute;
            left:50%;
            bottom:0.2rem;
            transform: translateX(-50%)
        }
        /deep/ .swiper-pagination-bullet {
            width: .16rem;
            height: .04rem;
            border-radius: .02rem;
            display: inline-block;
            background: #fff;
            opacity: .5;
            margin:0 .04rem;
        }
        /deep/ .swiper-pagination-bullet-active {
            opacity: 1;
        }
}
.reason-cards {
    display: flex;
    // justify-content: space-between;
    &__item {
        width:6.2rem;
        height:2.55rem;
        flex:none;
        border-radius: .1rem;
        background: url('../../assets/images/mobile/home_02_bs.png') no-repeat #fff;
        background-size: cover;
        background-position: 0rem -0.16rem;
    }
    &__title {
        font-family: PingFangSC-Medium;
        display: block;
        font-size: .28rem;
        color: #151515;
        margin-bottom: .2rem;
        padding:0 .4rem;
        padding-top:.6rem;
    }
    &__index {
        color: #FF2E00;
    }
    &__text {
        display: block;
        font-size: .28rem;
        color: #666666;
        line-height: .44rem;
        padding:0 .3rem;
    }
}

.teachers-carousel-img {
    height:4.52rem;
    margin-bottom: .58rem;
    background: url('../../assets/images/mobile/home_03_sx.png') no-repeat center top / auto 4.52rem;
}
.teachers-carousel {
    position: relative;
    // left:50%;
    // transform: translateX(-50%);
    // height: 100%;
    // padding-top: .5rem;
    .swiper-pagination-bullets {
        position: absolute;
        left:50%;
        transform: translateX(-50%);
        bottom: -.7rem;
    }

    /deep/ .swiper-pagination-bullet {
        width: .12rem;
        height: .12rem;
        border-radius: 50%;
        display: inline-block;
        background: #e6e6e6;
        margin:0 .04rem;
    }
    /deep/ .swiper-pagination-bullet-active {
        background: #ff2e00;
    }
    &__swiper{
        display:flex;
    }
    &__card {
        flex:none;
        // padding: 0 0.15rem;
        // height: 3.8rem;
        // width: 7rem !important;
        background: #fff;
        box-shadow: 0 0.04rem .22rem 0 #E1E1E1;
        border-radius: .1rem;
        display: flex;
        align-items: center;
        padding: 0 .2rem;
        // margin: 0 auto;
    }
    &__teacher {
        // margin-left: .2rem;
        width: 1.88rem;
        height: 2.4rem;
    }
    &__info{
        // margin-left: .2rem;
        // height:2.95rem;
        width: 4.8rem;
        margin: .2rem 0 .2rem .2rem;

    }
    &__row-1 {
        margin-bottom: .15rem;
        height: 0.45rem;
        display: flex;
        align-items: center;
    }
    &__row-2 {
        margin-bottom: .23rem;
    }

    &__name {
        font-family: PingFangSC-Semibold;
        font-size: .32rem;
        line-height: .45rem;
        color: #232628;
        width: 2rem;
    }
    // &__tag-wrap{
    //     transform: scale(0.5);
    //     margin-left:.07rem;
    //     transform-origin:center center;
    // }
    &__tag {
        display: block;
        height: 0.33rem;
        text-align: center;
        font-family: PingFangSC-Light;
        color: #FFFFFF;
        margin-left:.07rem;
        background-image: linear-gradient(-90deg, #333333 0%, #7A7A7A 100%);
        border-radius: 0 0.15rem 0.15rem 0.15rem;
        overflow: hidden;
        &--1 {
            width:1.5rem;
        }
        &--2 {
            width:1.2rem;
        }
        .fs10 {
            display: block;
            width: 200%;
            height: 200%;
            font-size: .20*2rem;
            line-height: .33*2rem;
            transform: scale(.5);
            transform-origin: left top;
        }
    }
    &__feature {
        font-family: PingFangSC-Light;
        font-size: .24rem;
        color: #333;
        letter-spacing: 0.1px;
        line-height:.33rem;
        // padding-left:.2rem;
        margin-bottom:.07rem;
        position: relative;
        &::before {
            content: ' ';
            display: inline-block;
            width: 0.06rem;
            height: 0.06rem;
            background: #333;
            border-radius: .03rem;
            vertical-align: middle;
            margin-right: .06rem;
        }
    }
}

.teacher-info {
    display: flex;
    line-height: .28rem;
    &__item {
        font-family: PingFangSC-Regular;
        font-size: .2rem;
        color: #191919;
        margin-right: 0.1rem;
    }
}

.lesson-carousel {
     position: absolute;
        left:50%;
        transform: translateX(-50%);
         .swiper-pagination-bullets {
            position: absolute;
            left:50%;
            transform: translateX(-50%);
            display: flex;
        }
        /deep/ .swiper-pagination-bullet {
            width: .16rem;
            height: .04rem;
            border-radius: .02rem;
            display: inline-block;
            background: #fff;
            opacity: .5;
            margin:0 .04rem;
        }
        /deep/ .swiper-pagination-bullet-active {
            opacity: 1;
        }
    &__main {
        width: 6.52rem*4;
    }

    &__card-group {
        display: flex;
    }

    &__card {
       width:6.52rem;
       height:8.2rem;
       padding: 0.18rem 0.22rem 0;
       background: url('../../assets/images/mobile/home_04_kc.png') no-repeat center / 6.52rem auto;
    }
    &__name{
        font-family: PingFangSC-Medium;
        font-size: .34rem;
        color: #000000;
        letter-spacing: 0;
        padding:.26rem .28rem 0;
    }
    &__name2 {
        font-family: PingFangSC-Regular;
        font-size: .22rem;
        color: #4D4D4D;
        padding:.05rem 0 .2rem .28rem;
    }
    &__item{
        padding-left: .28rem;
        padding-right: .2rem;
        letter-spacing: -0.01rem;
        font-family: PingFangSC-Regular;
        font-size: 0.25rem;
        color: #4D4D4D;
        line-height: .42rem;
        margin-bottom:.15rem;
    }
    &__item2{
        padding-left: .28rem;
        padding-right: .2rem;
        letter-spacing: -0.01rem;
        font-family: PingFangSC-Regular;
        font-size: 0.25rem;
        color: #4D4D4D;
        line-height: .42rem;
        margin-bottom:.15rem;
        &:last-of-type {
            margin-bottom: 0;
        }
    }
    &__txt {
        font-family: PingFangSC-Regular;
        font-size: .26rem;
        color: #606266;
        margin-left: .15rem;
    }
    &__label {
        display:block;
        font-family: PingFangSC-Regular;
        font-size: .26rem;
        color: #333333;
    }
    .sanjiao_down{
        width:0;
        height:0;
        overflow:hidden;
        font-size: 0;     /*是因为, 虽然宽高度为0, 但在IE6下会具有默认的 */
        line-height: 0;  /* 字体大小和行高, 导致盒子呈现被撑开的长矩形 */
        border-width: 0.1rem;
        border-style:solid;  /*ie6下会出现不透明的兼容问题*/
        border-color:transparent transparent transparent red;
    }
    .flex-center {
        display: flex;
        align-items: center;
    }

    &__btn {
        position: absolute;
        top: 235px;
        width: 50px;
        height: 50px;
        font-size: 20px;
        background: rgba(51, 51, 51, .7);
        text-align: center;
        line-height: 50px;
        color: #fff;
        border-radius: 50%;
        cursor: pointer;
        &:hover {
            background: rgba(51, 51, 51, .5);
        }

        &--prev {
            left: 0;
        }
        &--next {
            right: 0;
        }
    }
}
.study-helps {
    width: 4.1rem;
    height: 4.1rem;
    margin: 0 auto;
    background: url('../../assets/images/mobile/home_05_bg.png') no-repeat center / cover;
    position: relative;
    &__point {
        display: block;
        width: 0.36rem;
        height: 0.36rem;
        border-radius: 50%;
        background: #FC5A44;
        border: .04rem solid rgba(252,90,68,0.14);
        color: #FFFFFF;
        overflow: hidden;
        position: absolute;
        &--1 {
            left: -0.18rem;
            top: 1.94rem;
        }
        &--2 {
            left: 0.23rem;
            top: .66rem;
        }
        &--3 {
            left: 1.87rem;
            top: -0.17rem;
        }
        &--4 {
            left: 3.49rem;
            top: 0.67rem;
        }
        &--5 {
            left: 3.92rem;
            top: 1.94rem;
        }

        .fz10 {
            width: 200%;
            height: 200%;
            display: flex;
            font-size: .4rem;
            align-items: center;
            justify-content: center;
            transform: scale(.5);
            transform-origin: left top;
        }
    }
    &__text {
        font-size: 0.24rem;
        color: #333333;
        line-height: 0.33rem;
        position: absolute;
        &--1 {
            width: 1.26rem;
            text-align: right;
            left: -1.58rem;
            top: 1.79rem;
        }
        &--2 {
            width: 1.76rem;
            text-align: right;
            top: 0.51rem;
            left: -1.68rem;
        }
        &--3 {
            width: 2.61rem;
            text-align: center;
            top: -0.97rem;
            left: 0;
            right: 0;
            margin: 0 auto;
        }
        &--4 {
            width: 1.28rem;
            right: -1.17rem;
            top: .51rem;
        }
        &--5 {
            width: 1.22rem;
            right: -1.54rem;
            top: 1.79rem;
        }
    }
}
.value-added-services {
    width: 7rem;
    display: flex;
    flex-wrap: wrap;
    margin: 0 auto;

    &__item {
        flex: none;
        width: 3.2rem;
        height: 3.72rem;
        padding: 0.35rem 0.25rem 0;
        background: #FFFFFF;
        box-shadow: 0 10px 14px 0 rgba(0,0,0,0.06);
        margin: 0 0.15rem .3rem;
    }
    &__icon {
        display: block;
        width: 1.4rem;
        height: 1.4rem;
        margin: 0 auto;
        &--1 {
            background: url('../../assets/images/mobile/home_06_gh.png') no-repeat center / cover;
        }
        &--2 {
            background: url('../../assets/images/mobile/home_06_tp.png') no-repeat center / cover;
        }
        &--3 {
            background: url('../../assets/images/mobile/home_06_bj.png') no-repeat center / cover;
        }
        &--4 {
            background: url('../../assets/images/mobile/home_06_kt.png') no-repeat center / cover;
        }
    }
    &__title {
        font-size: .3rem;
        color: #000000;
        font-weight: bold;
        display: block;
        text-align: center;
        margin-bottom: .16rem;
        line-height: .42rem;
    }
    &__text {
        font-family: PingFangSC-Regular;
        font-size: .24rem;
        line-height: .33rem;
        color: #999999;
    }
}
.service-protection {
    width: 4.19rem;
    height: 4.19rem;
    margin: 0 auto;
    background: url('../../assets/images/mobile/home_07_bg.png') no-repeat top center / cover;
    &__pos {
        position: relative;
        height: 100%;
        width: 3.8rem;
        margin: 0 auto;
    }
    &__item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: absolute;
        &--1 {
            width: 1.2rem;
            top: 0.43rem;
            right: 4rem;
        }
        &--2 {
            width: 1.44rem;
            top: 0.43rem;
            left: 4rem;
        }
        &--3 {
            width: 1.2rem;
            top: 2.23rem;
            right: 4rem;
        }
        &--4 {
            width: 1.44rem;
            top: 2.23rem;
            left: 4rem;
        }
    }
    &__icon {
        display: block;
        width: .50rem;
        height: .50rem;
        margin-bottom: .1rem;
        &--1 {
            background: url('../../assets/images/mobile/home_07_st.png') no-repeat center / cover;
        }
        &--2 {
            background: url('../../assets/images/mobile/home_07_ls.png') no-repeat center / cover;
        }
        &--3 {
            background: url('../../assets/images/mobile/home_07_tk.png') no-repeat center / cover;
        }
        &--4 {
            background: url('../../assets/images/mobile/home_07_fw.png') no-repeat center / cover;
        }
    }
    &__text {
        display: block;
        flex: none;
        font-size: .22rem;
        color: #4D4D4D;
        text-align: center;
    }
}

.company-honor {
    width: 100%;
    position: relative;
    &__main {
        width: 2.8rem * 3;
        position: absolute;
        left: 50%;
        margin-left:-4.2rem;
        height: 3.4rem;

        .swiper-pagination-bullets {
            position: absolute;
            left:50%;
            bottom: 0.2rem;
            transform: translateX(-50%)
        }
        /deep/ .swiper-pagination-bullet {
            width: .16rem;
            height: .04rem;
            border-radius: .02rem;
            display: inline-block;
            background: #e6e6e6;
            margin:0 .04rem;
        }
        /deep/ .swiper-pagination-bullet-active {
            background: #FF2E00;
        }
    }
}
.honor-cards {
    display: flex;
    &__item {
        flex:none;
        width: 2.8rem;
    }
    &__img {
        display: block;
        width: 2.6rem;
        height: 2rem;
        margin: 0 auto;
        margin-bottom: .04rem;
    }
    &__text {
        display: block;
        font-size: .24rem;
        color: #4D4D4D;
        text-align: center;
    }
}

.hotline-and-qrcode {
    background: #333;
    height: 2.2rem;
    padding-left: 0.4rem;
    display: flex;
    &__tel {
        flex: 1;
        padding-top: 0.46rem;
    }
    &__tel-number {
        height: 0.56rem;
        padding-left: .44rem;
        background: url('../../assets/images/mobile/home_img_rx.png') no-repeat left center / .34rem;
        font-size: .4rem;
        line-height: .56rem;
        color: #FFFFFF;
        font-weight: bold;
        margin-bottom: .1rem;
    }
    &__tel-text {
        font-size: .24rem;
        font-weight: bold;
        color: #CCCCCC;
        line-height: .33rem;
    }

    &__warning {
        display: block;
        font-size: .24rem;
        color: #CCCCCC;
        // font-weight: bold;
        margin-top: 20px;
    }

    &__qrcodes {
        padding-top: .19rem;
        flex: none;
        display: flex;
    }
    &__qrcode {
        margin-right: 0.36rem;
    }
    &__qrcode-img {
        display: block;
        width: .92rem;
        height: .92rem;
        // padding: .04rem;
        border: .02rem solid #fff;
        margin: 0 auto .12rem;
    }
    &__qrcode-text {
        display: block;
        font-size: .18rem;
        color: #989898;
        text-align: center;
        line-height: 0.25rem;
    }
}
.company-infos {
    background: #414141;
    height: 1.85rem;
    padding-top: .3rem;
    padding-left: 0.4rem;

    a:hover {
        color: #999999;
        text-decoration: none;
    }
    a:link {
        color: #999999;
        text-decoration: none;
    }
    a:active {
        color: #999999;
        text-decoration: none;
    }
    a:visited {
        color: #999999;
        text-decoration: none;
    }

    &__item {
        font-size: .18rem;
        color: #999999;
        display: block;
        margin-bottom: .1rem;
        line-height: 0.25rem;
        height: 0.25rem;
        overflow: hidden;
        .fz9 {
            display: block;
            width: 200%;
            height: 200%;
            font-size: .36rem;
            transform: scale(.5);
            transform-origin: left top;
            display: flex;
            align-items: center;
        }
    }
}

.signup-bar {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 0 auto;
    z-index: 1000;
    height: 0.88rem;
    line-height: 0.88rem;
    display: flex;
    font-size: .28rem;
    display: flex;
    &__item {
        flex: 1;
        text-align: center;
        display: flex;
        justify-content: center;
        &--1 {
            background: #6a6a6a;
        }
        &--2 {
            background: #FF2E00;
        }
    }
    &__text {
        width: 1.62rem;
        display: block;
        padding-left: .4rem;
        color: #FFFFFF;
        text-decoration: none;
        &--1 {
            background: url('../../assets/images/mobile/home_icon_dh.png') no-repeat left center / .3rem auto;
        }
        &--2 {
            background: url('../../assets/images/mobile/home_icon_yy.png') no-repeat left center / .3rem auto;
        }
    }
}
.header-bar {
    height: 0.9rem;
    background: #fff;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    margin: 0 auto;
}
.promise {
    .promise-item {
        display: flex;
        width: 6.7rem;
        background: #FFFFFF;
        box-shadow: 0 .1rem .14rem 0 rgba(0,0,0,0.06);
        border-radius: .02rem;
        padding: .3rem 0 .37rem;
        margin: 0 auto .3rem;
    }
    .promise-item-pic {
        width: .43rem;
        height: .51rem;
        margin-left: .3rem;
    }
    .promise-item-name {
        font-family: PingFangSC-Medium;
        font-size: .28rem;
        color: #333333;
        font-weight: bold;
    }
    .promise-item-text {
        margin-top: .1rem;
        font-size: .22rem;
        font-family: PingFangSC-Regular;
        color: #666666;
        width: 5rem;
        line-height: .4rem;
    }
}
.txt-cut {
    overflow : hidden;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
}
</style>
<style lang="scss">
    @import '../../assets/styles/base/reset.scss';
</style>



// WEBPACK FOOTER //
// src/views/mobile/App.vue